import { useEffect, useRef, useState } from "react";
import { Feature, Map, Overlay } from "ol";
import Geometry from "ol/geom/Geometry";

export function useFeatureOverlay(map: Map | null, feature: Feature | null) {
	const focusOverlayElRef = useRef<HTMLElement | null>(null);

	const [featureOverlay, setFeatureOverlay] = useState<Overlay | null>(null);

	useEffect(() => {
		if (!map) return () => {};

		const overlay = new Overlay({
			element: focusOverlayElRef.current!,
			positioning: "bottom-left",
		});

		map.addOverlay(overlay);
		setFeatureOverlay(overlay);

		return () => {
			setFeatureOverlay(null);
			map.removeOverlay(overlay);
		};
	}, [map]);

	useEffect(() => {
		const geom = feature?.getGeometry();

		if (geom instanceof Geometry) {
			const [minx, , , maxy] = geom.getExtent();
			featureOverlay?.setPosition([minx, maxy]);
		}

		return () => {
			featureOverlay?.setPosition(undefined);
		};
	}, [feature]);

	return { focusOverlayElRef };
}